// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c13b42e6","455":"e14f07f6","551":"1744cf61","842":"ba7311e4","977":"ee752381"}[chunkId] + ".chunk.js";
};